export const lightVariant = {
  root: {
    backgroundColor: 'neutral.black',
    gap: 0.25,
  },
  list: {
    alignSelf: 'center',
    width: 'fit-content',
    backgroundColor: 'neutral.900',
    gap: 8,
  },
  trigger: {
    flexGrow: 0,
    backgroundColor: 'neutral.900',
    color: 'neutral.white',
    padding: 0,
    _selected: {
      boxShadow: 'none',
      _after: {
        content: '""',
        position: 'absolute',
        bottom: '11px',
        left: 0,
        width: '100%',
        height: '4px',
        backgroundColor: 'blue.500',
        borderRadius: 'none',
        boxShadow: '0 0 4px blue.500',
      },
    },
    "&:hover:not([aria-selected='true']):not([aria-disabled='true'])": {
      color: 'skyBlue',
    },
    _disabled: {
      color: 'neutral.300',
    },
  },
  contentGroup: {
    background: 'neutral.black',
  },
  content: {
    background: 'neutral.black',
  },
};
